import { createContext } from 'react'

export interface IContractorDetailsModalContext {
  statusIsUpdating: boolean
  setStatusIsUpdating(value: boolean): void
  triggerStatusDelayedContractorRefresh(): void
}

export const ContractorDetailsModalContext = createContext<IContractorDetailsModalContext>({
  statusIsUpdating: false,
  setStatusIsUpdating: () => {},
  triggerStatusDelayedContractorRefresh: () => {},
})
